import React from "react";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import SelectedWork from "./components/SelectedWork";
import Philosophy from "./components/Philosophy";
import Capabilities from "./components/Capabilities";
import About from "./components/About";
import Pricing from "./components/Pricing";
import Inquiry from "./components/Inquiry";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <SelectedWork />
        <Philosophy />
        <Capabilities />
        <About />
        <Pricing />
        <Inquiry />
      </main>
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
